module.exports = __webpack_public_path__ + "static/media/022.dc716460.jpg";